export default "data:text/javascript;base64,ZXhwb3J0ICogZnJvbSAiLi9tc3BSb3V0ZXMiOwpleHBvcnQgKiBmcm9tICIuL2N1c3RvbWVyUm91dGVzIjsKCmV4cG9ydCBkZWZhdWx0IHt9Owo="